import React/*, { Component }*/ from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import Currency from 'react-currency-formatter';
import localize from '../hoc/localize';
import { AppContext } from '../context/AppContext';
import { isEmpty, /*removeSpaces, */getLocaleDateString, convertDateToInteger } from '../helpers';
import moment from 'moment';
import infoIcon from "../img/icon-info.png";
import vendorIcon from '../img/icon-suggestions.png';
import reportIcon from '../img/icon-report.png';
import ReactTooltip from 'react-tooltip';

// a list of all the KPIs that are drill-downable
//const DRILLDOWN_KPIS = [
//    "obsoleteinventory", "agedinventory"
//];

class CardGrid extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        type: PropTypes.oneOf(['kpis', 'vendors', 'reports', 'support']),
        handleClick: PropTypes.func,

        // given the data that was passed in (an array of objects), specify which fields hold the text and which holds the id
        labelFieldName: PropTypes.string,
        idFieldName: PropTypes.string
    }

    state = {
        isNarrow: false
    }

    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
    }

    handleClick = (event) => {
        this.props.handleClick();
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        if (window.innerWidth < 1000) {
            this.setState({ isNarrow: true })
        }
        else {
            this.setState({ isNarrow: false })
        }
    };

    parseTitle(reportType) {
        //parse reportType slug into localisation code for rendering, adjust this when adding new reports
        switch (reportType) {
            case "top-seller-items":
                return "m0523";
            case "slow-moving-items":
                return "m0524";
            case "top-performers":
                return "m0525";
            case "top-overstocking":
                return "m0526";
            case "suggested-order-history":
                return "m0527";
            case "aged-inventory":
                return "m0528";
            case "obsolete-inventory":
                return "m0529";
            case "inventory-mix-comparison":
                return "m0530";
            case "inventory-mix-history":
                return "m0531";
            case "part-sales-history":
                return "m0532";
            case "som-usage-stats":
                return "m0533";
            case "som-adoption":
                return "m0534";
            case "parts-booking-tool":
                return "m0594";
            case "parts-booking-history":
                return "m0597";
            case "parts-return":
                return "m0605";
            default:
                return ""
        }

    }

    render() {
        var className = "";
        switch (this.props.type) {
            case "kpis":
                //className = "grid-row compo-figure-cards";
                className = "card-grid kpis";
                break;
            case "vendors":
                className = "card-grid vendors";
                break;
            case "reports":
                className = "card-grid reports";
                break;
            default:
                break;
        }

        //<article class="grid-row compo-figure-cards">

        return (
            <React.Fragment>
                <article className={className}>

                    {
                        (this.props.data) ? this.props.data.map((item, index) => {
                            switch (this.props.type) {
                                case "kpis":
                                    return <KPICardLocalized
                                        key={item.metric}
                                        dataItem={item}
                                    />
                                case "vendors":
                                    return <VendorCardLocalized
                                        key={item.orgVendorID}
                                        vendor={item}
                                    />
                                case "reports":
                                    return <ReportCardLocalized
                                        key={index}
                                        label={this.parseTitle(item.reportID)}
                                        linkParams={item[this.props.linkParamsFieldName]}
                                        link={item.link}
                                    />
                                default:
                                    return <React.Fragment />;
                            }
                        }) : ""
                    }
                </article>
                {
                    // initiate tooltips for KPI cards
                    (this.props.type === "kpis") ?
                        (<ReactTooltip className="som-tooltip" place={this.state.isNarrow ? "right" : "top"} html={true} type="dark" effect="solid" event="mouseover"
                            eventOff="mouseout" offset={{ top: -5 }} multiline={true} />) :
                        (<React.Fragment />)
                }
            </React.Fragment>

        );
    }
}
export default localize(CardGrid);

CardGrid.defaultProps = {
    labelFieldName: "label",
    linkParamsFieldName: "linkParams",
    idFieldName: "id"
}

const VendorCard = (props) => {

    //const hasLink = (props.figure > 0);
    const localeDateString = getLocaleDateString().toUpperCase();
    const today = new Date();
    ////Even if it�s day 1 of the month, JavaScript is logical enough and it will point to the last day of the previous month.
    //const yesterday = new Date(today.setDate(today.getDate() - 1))
    const intToday = convertDateToInteger(today);
    let poDateClassName = 'poDate';
    if (props.vendor.poDate < intToday)
        poDateClassName += ' old';

    //!DBTRANS! @m0011@ %space%suggested items to purchase !DEVNOTE! Label
    //!DBTRANS! @m0012@ PO Date:  !DEVNOTE! Date Label
    //!DBTRANS! @m0523@ Top Seller Items !DEVNOTE! Report Title
    //!DBTRANS! @m0524@ Slow Moving Items !DEVNOTE! Report Title
    //!DBTRANS! @m0525@ Top Performers !DEVNOTE! Report Title
    //!DBTRANS! @m0526@ Top Overstocking !DEVNOTE! Report Title
    //!DBTRANS! @m0527@ Suggested Order History !DEVNOTE! Report Title
    //!DBTRANS! @m0528@ Aged Inventory !DEVNOTE! Report Title
    //!DBTRANS! @m0529@ Obsolete Inventory !DEVNOTE! Report Title
    //!DBTRANS! @m0530@ Inventory Mix Comparison !DEVNOTE! Report Title
    //!DBTRANS! @m0531@ Inventory Mix History !DEVNOTE! Report Title
    //!DBTRANS! @m0532@ Part Sales History !DEVNOTE! Report Title
    //!DBTRANS! @m0533@ SOM Usage Stats !DEVNOTE! Report Title
    //!DBTRANS! @m0534@ SOM Adoption !DEVNOTE! Report Title
    //!DBTRANS! @m0379@ Reports !DEVNOTE! Sidebar Title 
    //!DBTRANS! @m0381@ Admin reports !DEVNOTE! Title
    //!DBTRANS! @m0511@ Top 100 parts with highest quantity sold in selected time interval. !DEVNOTE! Report description
    //!DBTRANS! @m0512@ Lists all organizations in user’s scope ordered from highest performer to the lowest based on combined ranking of monthly KPI values. !DEVNOTE! Report description
    //!DBTRANS! @m0513@ Lists all organizations in user’s scope sorted from the highest aged inventory value to the lowest. !DEVNOTE! Report description
    //!DBTRANS! @m0514@ Lists all Suggested Orders in selected time interval for all organizations in user’s scope. !DEVNOTE! Report description
    //!DBTRANS! @m0515@ Top 100 parts that are aged, obsolete, or have low turnover rate, sorted by highest inventory value and/or qty. In case of multiple organization view, number of organizations in user’s scope carrying the part is also considered in ranking. !DEVNOTE! Report description
    //!DBTRANS! @m0516@ Parts that didn't have any sales in last 12 months, sorted by highest inventory value and/or qty. In case of multiple organization view, number of organizations in user’s scope carrying the part is also considered in ranking. !DEVNOTE! Report description
    //!DBTRANS! @m0517@ Parts that are flagged obsolete, sorted by highest inventory value and/or qty. !DEVNOTE! Report description
    //!DBTRANS! @m0518@ Lists inventory mix by percentage for comparison purposes. !DEVNOTE! Report description
    //!DBTRANS! @m0519@ Lists monthly inventory mix stats history (all available months) for a dealer. !DEVNOTE! Report description
    //!DBTRANS! @m0520@ A report of part sales statistics within a selected date interval (Default= last 30 days). !DEVNOTE! Report description
    //!DBTRANS! @m0521@ A report of usage statistics of Super SOM. !DEVNOTE! Report description
    //!DBTRANS! @m0522@ A report of adoption rate of Super SOM. !DEVNOTE! Report description
    //!DBTRANS! @m0594@ Parts Booking !DEVNOTE! Report Title
    //!DBTRANS! @m0595@ Tool to generate parts bookings !DEVNOTE! Report description
    //!DBTRANS! @m0598@ Previously saved Parts Bookings !DEVNOTE! Report description
    //!DBTRANS! @m0619@ Tool to generate parts returns !DEVNOTE! Report description

    const cardContent = (
        <figure>
            <div className="header">
                <label className="title">{props.vendor.vendorName}</label>
                <figcaption className="icon">
                    <img src={vendorIcon} alt="" />
                </figcaption>
            </div>
            <figcaption className="figure">
                <strong>{props.vendor.suggestedOrders}</strong>
                {props.returnLocalizedString("m0011")}
            </figcaption>
            {
                (props.vendor.poDate > 0) ? (
                    <figcaption className={poDateClassName}>
                        {props.returnLocalizedString("m0012")} <strong>{moment(props.vendor.poDate, 'YYYYMMDD').format(localeDateString)}</strong>
                    </figcaption>) : (<figcaption>&nbsp;</figcaption>)
            }


        </figure>
    );
    return (


        // if (hasLink){

        <Link to={props.vendor.link}>
            {cardContent}
        </Link>

    );
}
const VendorCardLocalized = localize(VendorCard)

class KPICard extends React.Component {
    static propTypes = {
        // figure: PropTypes.number,
        // dataType: PropTypes.string 
        dataItem: PropTypes.object
    }
    state = {
        clickedDrilldown: false
    }
    getFormattedFigure = () => {
        const figure = this.props.dataItem.value;
        const dataType = this.props.dataItem.dataType;

        let formattedFigure = '';
        if (!isEmpty(figure)) {
            formattedFigure = figure;

            if (!isEmpty(dataType)) {
                switch (dataType) {
                    case 'C':
                        let currencyCode = this.context.state.currencyCode;
                        if (isEmpty(currencyCode)) currencyCode = "USD";

                        let currencySymbol = this.context.state.currencySymbol;
                        if (isEmpty(currencySymbol)) currencySymbol = "$";

                        return (<Currency quantity={figure} currency={currencyCode} symbol={currencySymbol} locale={this.props.uiLanguage} />);
                    case '%':
                        return `${formattedFigure.toLocaleString(this.props.uiLanguage)}%`;
                    case 'N':
                        return formattedFigure.toLocaleString(this.props.uiLanguage);
                    default:
                        return formattedFigure;
                }

            }
            return formattedFigure;

        } else {
            //!DBTRANS! @m0013@ N/A !DEVNOTE! Not Applicable Label
            return this.props.returnLocalizedString("m0013");
        }
    }
    handleDrilldown = () => {
        this.setState({ clickedDrilldown: true })
    }


    render() {
        var metricName = ""
        var description = ""
        const link = this.props.dataItem.link;
        switch (this.props.dataItem.metric) {
            case 'Inventory Value':
                metricName = "m0388";
                description = "m0389";
                break;
            case 'This Month Sales':
                metricName = "m0390";
                description = "m0391";
                break;
            case 'This Month Gross Profit':
                metricName = "m0392";
                description = "m0393";
                break;
            case 'Aged Inventory':
                metricName = "m0394";
                description = "m0395";
                break;
            case 'Obsolete Inventory':
                metricName = "m0396";
                description = "m0397";
                break;
            case 'YTD Gross Profit':
                metricName = "m0398";
                description = "m0399";
                break;
            case 'GMROI':
                metricName = "m0400";
                description = "m0401";
                break;
            case 'Inventory Turnover Rate':
                metricName = "m0402";
                description = "m0403";
                break;
            default:
                break;
        }
        let cardProps = {};

        if (!isEmpty(link)) {
            cardProps = {
                onClick: this.handleDrilldown,

            }
        }

        //!DBTRANS! @m0022@ Click to drill down !DEVNOTE! Button Label
        const title = (isEmpty(link) ? "" : this.props.returnLocalizedString("m0022"))

        const card = (
            <figure title={title} className={`card ${!isEmpty(link) ? 'drillable' : ''}`} {...cardProps}>
                <div className="text">
                    <label className="title">{this.props.returnLocalizedString(metricName)}</label>

                    <figcaption className="figure">
                        {this.getFormattedFigure()}
                    </figcaption>
                </div>

                <img title='' src={infoIcon} className="info" data-tip={this.props.returnLocalizedString(description)} alt="" />

            </figure>
        );

        if (this.state.clickedDrilldown && !isEmpty(link)) {
            return <Redirect to={link} />;
        } else {
            return card;
        }



    }
}
KPICard.contextType = AppContext;
const KPICardLocalized = localize(KPICard)

//const TooltipContentTemplate = (props) => {

//    return (
//        <div className="som-tooltip" ><strong>{props.title}</strong></div>
//    );

//}

const ReportCard = (props) => {
    return (
        <Link to={{
            pathname: props.link,
            search: props.linkParams,
            hash: '',

        }}>
            <figure>
                <div className="header">
                    <label className="title">{props.returnLocalizedString(props.label)}</label>
                    <figcaption className="icon">
                        <img src={reportIcon} alt="" />
                    </figcaption>
                </div>
            </figure>
        </Link>
    );
}
const ReportCardLocalized = localize(ReportCard);


// WEBPACK FOOTER //
// ./src/components/CardGrid.js